export const config = {
  AboutIntro: {
    title: 'About you',
    description: 'Tell us a little bit about yourself so your optometrist can prepare for your appointment.',
  },
  AboutYouForm: {
    yourDetailsTitle: 'Your details',
    sectionDataTest: 'YourAppointmentOpticians',
  },
};
